<template>
    <div class="forecast">
        <div class="tit">
            <img src="@/assets/common/titLogo.png"
                 alt="" />
            <span>
                {{
					lotteryType == 0 ? '双色球':
					lotteryType == 1 ? '大乐透':
					lotteryType == 2 ? '福彩3D':
					lotteryType == 3 ? '排列三':''
				}}指标学霸最新预测
            </span>
        </div>
        <div class="cont"
		style="position:relative"
             v-loading="listLoading">
            <div v-for="(item, index) in list"
                 :key="index" style="font-size:14px;">
                <span @click="view_history2(item,(
							lotteryType == 0 ? 'ssq':
							lotteryType == 1 ? 'dlt':
							lotteryType == 2 ? 'fcse':
							lotteryType == 3 ? 'pls':''
						))" style="cursor: pointer;color:#4084b4">{{item.nickName}}</span>

                
                <span style="font-size:12px">
                	<!-- <span>{{item.realBetNumber}}注</span> -->
					<span v-if="item.realBetNumber == '0'"></span>
                    <span v-else>{{item.realBetNumber}}注</span>
					<!-- {{item.preIndexTypeLabel}} -->
                    <span v-if="item.preIndexTypeLabel=='杀6蓝'||item.preIndexTypeLabel=='杀4蓝'
                    ||item.preIndexTypeLabel=='围4蓝'||item.preIndexTypeLabel=='围3后'">
                        {{item.preIndexTypeLabel}}</span>
                    </span>
                <span>{{item.coin}}缩币</span>
                <span>{{item.achievement}}</span>
            </div>

            <div v-if="list && list.length === 0 && !error" style="
					position: absolute;
					left: 50%;
					top: 50%;
					transform: translate(-50%, -50%);
					font-size: 40px;
					border-bottom: 0;
					color: rgba(0, 0, 0, 0.3);
				">暂无内容</div>

			<div v-if="error" style="
					position: absolute;
					left: 50%;
					top: 50%;
					transform: translate(-50%, -50%);
					text-align: center;
					color: rgba(0, 0, 0, 0.5);
					font-size: 14px;
				">
				<div style="margin-bottom: 10px;">数据加载失败（接口超时）</div>
				<el-button size="mini" type="primary" @click="getList">点击重试</el-button>
			</div>
			</div>

            <!-- <div class="tz"
                 v-if="lotteryType == 0">
                <div class="tit">
                    <span v-if="lotteryType == 0">双色球红球特征</span>
                    <span v-if="lotteryType == 1">大乐透前后区特征</span>
                </div>
                <div class="btn"
                     v-if="lotteryType == 0">双色球红球特征</div>
                <div class="btn"
                     v-if="lotteryType == 1">开奖号码特征</div>
                <div class="link">第{{db.cycle}}期开奖信息</div>
                <div class="cont"
                     v-if="lotteryType == 0">
                    <div>红球: {{db.red}}</div>
                    <div>篮球: {{db.blue}}</div>
                    <div>奇偶比: {{db.parity}}</div>
                    <div>红球和值: {{db.redSum}}</div>
                    <div>与上期没有同号:{{db.duplicateNumbers}}</div>
                    <div>三区比: {{db.threeZoneRatio}}</div>
                    <div>AC值:{{db.ac}}</div>
                    <div>极距:{{db.range}}</div>
                </div>
            </div> -->
		
    </div>
</template>

<script>
import { queryPreRankingList } from "@/api/home/index"
// import { queryColorfulSeedByType } from '@/api/home'
export default {
    props: ["lotteryType"],
    data () {
        return {
            list: [],
			listLoading:false,
            error: false,

            db: {}
        };
    },
    mounted () {
        this.getList();

        // queryColorfulSeedByType(this.lotteryType).then(res => this.db = res.data)
    },
    methods: {
        view_history2 (item, preType) {
		    this.$router.push({
		    	path: '/dating_viewHistory',
		    	query:{
		    		shrinkId: item.shrinkId || item.createUser,
		    		number: item.number,
		    		userName: item.nickName,
		    		preType,
		    	}
		    })
        },
		// 查看历史记录
		view_history (item, preIndexType, preType, backNumber) {
			
			this.$router.addRoute({
				path: '/dating_viewHistory',
				name: 'dating_viewHistory', // 假设你有一个名字
				component: () => import('@/views/homePage/menu/suoshuidan_dating/components/viewHistory.vue')
			})

			const routeExists = this.$router.options.routes.some(route => route.name === 'dating_viewHistory');
			let trim = setInterval(() => {
				if (!routeExists) {
					clearInterval(trim)
					// 使用全局前置守卫来执行操作
					this.$router.push({
						path: '/dating_viewHistory',
						query: {
							item,
							preIndexType:item.preIndexType,
							preType:this.lotteryType,
							backNumber:item.number
						}
					})
				}

			}, 100)

			// this.$refs.viewHistory.init(item, preIndexType, preType, backNumber)
		},
        getList () {
			this.listLoading = true
            this.error = false
            // 接口文档：preIndexType 不填 = 查「指标学霸最新预测」；填了才查「指标考核导航」的排名。
            // 本组件就是学霸最新预测，故只传 preType（risingNo 不传默认取前 10，这里显式写上便于阅读）。
            queryPreRankingList({
                preType: this.lotteryType,
                risingNo: 10,
            }).then(async res => {
				this.listLoading = false
                let list = res.data && await this.getIndexType(this.lotteryType, res.data)
                this.list = list || []
            }).catch(err => {
                console.error('指标学霸预测加载失败', err)
				this.listLoading = false
                this.list = []
                this.error = true
            })
        },

        async getIndexType (lotteryType, lotteryDb) {

            let resDb = [];

            let params = [
                'pre_double_index_type',   	    //双色球
                'pre_lottery_index_type',	    //大乐透
                'pre_fucai3d_index_type',	    //福彩3D
                'pre_pailiesan_index_type',	    //排列三
            ]

            let res = await this.$utils.getDictionary(params[lotteryType])

            lotteryDb && lotteryDb.forEach(item => {
                let handleDb = {
                    ...item,
                    preIndexTypeLabel: res.data.filter(ite => ite.dictValue == item.preIndexType)[0].dictLabel
                }
                resDb.push(handleDb)
            });

            return JSON.parse(JSON.stringify(resDb))
        },

    },
};
</script>

<style lang="scss" scoped>
.forecast {
    height: calc(100% - 36px);
    .tit {
        font-weight: bold;
        padding: 10px;
        padding-top: 0;
        border-bottom: 1px solid rgba(0, 0, 0, 0.07);
        display: flex;
        align-items: center;
        img {
            width: 20px;
            margin-right: 10px;
        }
    }
    .cont {
        height: 100%;
		border: 1px solid #8fb3da;
        div {
            border-bottom: 1px solid rgba(0, 0, 0, 0.07);
			padding: 0 10px ;
            display: flex;
            justify-content: space-between;
			&:last-child{
				border-bottom: 0;
			}
            span {
                padding: 16.5px 0;
                flex: 1;
                text-align: center;
                white-space: nowrap;
            }
            // &.tz {
            //     display: flex;
            //     flex-direction: column;
            // }
        }
    }
}
</style>
